import type { Organization } from '@/types/organization'
import type { Location } from '@/model/location.model.ts'
import type { Product } from '@/types/product'
import type { Project } from '@/types/project'
import type { Nullish } from '@logistiek-zonder-papier/lzp-library'

export type EcmrJourneyTemplate = {
  //TODO complete this type only origin and destination fields are defined
  ecmrGeadresseerde: Organization
  ecmrAfzender: Organization
  ecmrPlaatsInontvangstname: Location
  ecmrPlaatsAflevering: Location
}

export type JourneyTemplate = {
  active: boolean
  allowedToActivate: boolean
  bestemmingsAdres?: Record<string, unknown>
  createdByOrganisation?: number
  createdDate: string
  deleted: boolean
  extraOptions?: Record<string, unknown>
  id?: number
  idfStatus: number
  intern: boolean
  internAsInt: number
  invisible: boolean
  materialen?: Product[]
  project: Project
  ritBeschikbaar: number
  status?: string
  stroomIHM?: Organization
  stroomName: string
  stroomProducent?: Organization
  stroomUUID: string
  stroomUUID_UNIQUE: string
  stroomVervoerder?: Organization[]
  stroomVerwerker: Organization
  transportInstructies?: string
  verzendAdres?: Record<string, unknown>
  sharedWith?: Nullish | Organization
}

export type JourneyStatus =
  | 'VOORBEREIDING'
  | 'ONDERTEKEND'
  | 'GEANNULEERD'
  | 'VERTROKKEN'
  | 'STOPGEZET'
  | 'AANGEKOMEN'
  | 'FINAAL'
  | 'TEST_RIT'

export const VOORBEREIDING = 'VOORBEREIDING' as const
export const VOORBEREIDING_LABEL = { id: VOORBEREIDING, label: 'Voorbereiding' } as const

export const ONDERTEKEND = 'ONDERTEKEND' as const
export const ONDERTEKEND_LABEL = { id: ONDERTEKEND, label: 'Ondertekend' } as const

export const GEANNULEERD = 'GEANNULEERD' as const
export const GEANNULEERD_LABEL = { id: GEANNULEERD, label: 'Geannuleerd' } as const

export const VERTROKKEN = 'VERTROKKEN' as const
export const VERTROKKEN_LABEL = { id: VERTROKKEN, label: 'Vertrokken' } as const

export const STOPGEZET = 'STOPGEZET' as const
export const STOPGEZET_LABEL = { id: STOPGEZET, label: 'Stopgezet' } as const

export const AANGEKOMEN = 'AANGEKOMEN' as const
export const AANGEKOMEN_LABEL = { id: AANGEKOMEN, label: 'Aangekomen' } as const

export const FINAAL = 'FINAAL' as const
export const FINAAL_LABEL = { id: FINAAL, label: 'Finaal' } as const

export const TEST_RIT = 'TEST_RIT' as const
export const TEST_RIT_LABEL = { id: TEST_RIT, label: 'Test rit' } as const

export type StatusOption = {
  id: JourneyStatus
  label: string
}

export const STATUS_LABEL: Record<JourneyStatus, StatusOption> = {
  VOORBEREIDING: VOORBEREIDING_LABEL,
  ONDERTEKEND: ONDERTEKEND_LABEL,
  GEANNULEERD: GEANNULEERD_LABEL,
  VERTROKKEN: VERTROKKEN_LABEL,
  STOPGEZET: STOPGEZET_LABEL,
  AANGEKOMEN: AANGEKOMEN_LABEL,
  FINAAL: FINAAL_LABEL,
  TEST_RIT: TEST_RIT_LABEL,
} as const

export const STATUS_ORDER: Record<JourneyStatus, number> = {
  VOORBEREIDING: 0,
  ONDERTEKEND: 1,
  GEANNULEERD: 4,
  VERTROKKEN: 2,
  STOPGEZET: 3,
  AANGEKOMEN: 3,
  FINAAL: 4,
  TEST_RIT: 5,
} as const
